import React from "react";
import MyRouter from "routers/index";
import SiteDisabled from "Scadenza/SiteDisabled";

function App() {

 // Recupera la data dalla variabile d'ambiente
 const siteActiveDate = process.env.REACT_APP_SITE_ACTIVE_DATE;

 // Funzione per verificare se il sito deve essere disabilitato
 const isSiteDisabled = (): boolean => {
   if (!siteActiveDate) return false; // Se manca la data, sito attivo

   // Converte la stringa in data
   const currentDate = new Date();
   const targetDate = new Date(siteActiveDate);

   // Controlla se la data attuale è successiva a quella impostata
   return currentDate >= targetDate;
 };

 // Se il sito è disabilitato, mostra la schermata di blocco
 if (isSiteDisabled()) {
   return <SiteDisabled />;
 }

 // Altrimenti, mostra i contenuti
  return (
    <div className="bg-white text-base dark:bg-neutral-900 text-neutral-900 dark:text-neutral-200">
      <MyRouter />
    </div>
  );
}

export default App;
